'use client';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContentWrapper = styled(Box)`
  margin: 0 32px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
`;
